import { render } from "./ConfirmarPago.vue?vue&type=template&id=810b475c&scoped=true"
import script from "./ConfirmarPago.vue?vue&type=script&lang=js"
export * from "./ConfirmarPago.vue?vue&type=script&lang=js"

import "./ConfirmarPago.vue?vue&type=style&index=0&id=810b475c&scoped=true&lang=css"

import exportComponent from "/var/www/adm3.argusblack/adm3.argusblack/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-810b475c"]])

export default __exports__